import ExcelJS from "exceljs";
import { Device } from "../types/DeviceType";

export function organizeDeviceData(data: Device[]) {
  if (!data || data.length === 0) {
    return [];
  }
  // Check if data is an array and has elements
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }
  let res = data.map((val) => {
    return {
      serialNumber: val.serialNumber,
      creationDate: val.creationDate,
      firmwareVersionId: val.hardwareVersionId,
      hardwareVersionId: val.softmwareVersionId,
      patient:
        val.patient?.firstName && val.patient?.lastName
          ? `${val.patient.firstName} ${val.patient.lastName}`
          : "",
      site: val.site?.SiteName || "",
      relatedHCP:
        val.relatedHCP?.firstName && val.relatedHCP?.lastName
          ? `${val.relatedHCP.firstName} ${val.relatedHCP.lastName}`
          : "",
      status: val.status,
      //batteryLevel: val.batteryLevel,
      lastSync: val.lastSync || "",
      errors: Array.isArray(val.errors) ? val.errors : [],
      applicationVersion: val.applicationVersion,
    };
  });

  return res;
}

const processFile = async (file: File) => {
  try {
    const workbook = new ExcelJS.Workbook();
    const buffer = await file.arrayBuffer();
    await workbook.xlsx.load(buffer);

    // Assumes the first worksheet contains the serial numbers
    const worksheet = workbook.worksheets[0];
    const serialNumbers: string[] = [];

    worksheet.eachRow((row, rowIndex) => {
      if (rowIndex > 1) {
        // Skip header row
        const serialNumber = row.getCell("A").value?.toString(); // Assuming "A" column
        if (serialNumber) {
          serialNumbers.push(serialNumber);
        }
      }
    });

    console.log("Serial Numbers Extracted:", serialNumbers);
    return serialNumbers;
  } catch (error) {
    console.error("Error processing the file:", error);
    throw new Error("Failed to process the file.");
  }
};
const organizeDeviceSettings = (data: any[]) => {
  if (!data || !Array.isArray(data)) {
    console.error("Invalid data passed to organizeDeviceSettings:", data);
    return [];
  }
  const organizedData = data.map((item) => ({
    symbol: item.label,
    value: item.value,
    range: item.range,
    units: item.units,
  }));
  return organizedData;
};
function organizeFotaDevicesTableData(data: Device[]) {
  let res = data.map((val) => {
    return {
      serialNumber: val.serialNumber,
      creationDate: val.creationDate,
      firmwareVersionId: val.softmwareVersionId,
      patient:
        val.patient?.firstName && val.patient?.lastName
          ? `${val.patient.firstName} ${val.patient.lastName}`
          : "",
      site: val.site?.SiteName || "",
      relatedHCP:
        val.relatedHCP?.firstName && val.relatedHCP?.lastName
          ? `${val.relatedHCP.firstName} ${val.relatedHCP.lastName}`
          : "",
      status: val.status,
    };
  });

  return res;
}

export { organizeDeviceSettings, processFile, organizeFotaDevicesTableData };
